import { Info } from "lucide-react";
import { MwpBadge, MWP_TIERS, NextTier } from "@/components/MwpBadge";
import { fmtMwp } from "@/components/MwpBoard";
import { BuyLink } from "@/components/BuyLink";

const STEPS = [
  ["Buy $MWP on Zora", "Tap the Buy on Zora button and buy any amount of $MWP."],
  ["Send it to your linked wallet", "In your Zora wallet, tap Send, choose $MWP, and send it on the Base network to the same wallet address you linked above."],
  ["Tap Re-check", "Come back here and tap Re-check on your wallet. Your badge and credit bonus switch on."],
];

export default function MwpSection({ wallet }) {
  const m = wallet?.mwp;
  return (
    <section data-testid="wallet-mwp" className="glass rounded-2xl p-6 mb-8">
      <div className="flex flex-wrap items-start justify-between gap-4 mb-5">
        <div className="flex items-center gap-4">
          <img src="/brand/mwp_coin.webp" alt="" className="w-14 h-14 rounded-full" />
          <div>
            <p className="text-[11px] font-mono-game text-slate-500">ZORA COIN · BASE NETWORK</p>
            <h2 className="font-display text-2xl text-amber-100">$MWP holder badge</h2>
          </div>
        </div>
        <BuyLink k="mwp" full testid="wallet-mwp-buy" className="!w-auto px-6" />
      </div>
      <div data-testid="wallet-mwp-status" className="rounded-xl border border-slate-700/70 bg-[#061016]/80 p-4 mb-5 flex flex-wrap items-center gap-4">
        {m?.tier ? (
          <>
            <MwpBadge tier={m.tier} big testid="wallet-mwp-badge" />
            <span className="text-sm text-slate-300"><b data-testid="wallet-mwp-balance" className="font-mono-game text-amber-200">{fmtMwp(m.balance)}</b> $MWP · <span className="text-emerald-300">+{MWP_TIERS[m.tier].bonus}% credits</span> from battles, quests and login</span>
          </>
        ) : null}
        {m?.tier ? null : <span data-testid="wallet-mwp-none" className="text-sm text-slate-400">{wallet ? "No $MWP yet in your linked wallet." : "Link a wallet above first. $MWP is read from that same wallet."}</span>}
        {wallet && <div className="w-full"><NextTier balance={m?.balance || 0} testid="wallet-mwp-next-tier" /></div>}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-6">
        {Object.entries(MWP_TIERS).map(([k, t]) => (
          <div key={k} data-testid={`wallet-mwp-tier-${k}`} className={`rounded-xl border p-3 ${m?.tier === k ? "border-amber-300/70 bg-amber-500/10" : "border-slate-800 bg-slate-950/50"}`}>
            <MwpBadge tier={k} />
            <p className="text-sm text-slate-200 mt-2">{t.need}</p>
            <p className="text-xs text-slate-500">+{t.bonus}% credits{k === "platinum" ? " · crown frame" : ""}</p>
          </div>
        ))}
      </div>
      <p className="text-[11px] font-mono-game text-amber-300/80 mb-3">HOW TO GET YOUR BADGE</p>
      <ol data-testid="wallet-mwp-steps" className="grid md:grid-cols-3 gap-3">
        {STEPS.map(([t, d], i) => (
          <li key={t} className="flex gap-3 rounded-xl border border-slate-800 bg-slate-950/50 p-4">
            <span className="w-8 h-8 shrink-0 rounded-full border border-amber-400/50 grid place-items-center font-mono-game text-amber-200">{i + 1}</span>
            <div><p className="text-sm text-white font-semibold">{t}</p><p className="text-xs text-slate-400 mt-1">{d}</p></div>
          </li>
        ))}
      </ol>
      <p data-testid="wallet-mwp-note" className="text-xs text-slate-500 mt-4 flex items-start gap-2"><Info className="w-3.5 h-3.5 mt-0.5 shrink-0" />$MWP lives on the Base network. Only the wallet linked above is checked, and the site re-checks it every 10 minutes while you play.</p>
    </section>
  );
}
